import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAlert } from '../contexts/AlertContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const StudentsPage = () => {
  const navigate = useNavigate();
  const { showSuccess, showError, showWarning, showInfo } = useAlert();
  const [students, setStudents] = useState([]);
  const [books, setBooks] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [showQuizSelector, setShowQuizSelector] = useState({});
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    grade: ''
  });

  useEffect(() => {
    fetchStudents();
    fetchBooks();
  }, []);

  const fetchStudents = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/students/`);
      setStudents(response.data);
    } catch (error) {
      console.error('Error fetching students:', error);
    }
  };

  const fetchBooks = async () => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/books/`);
      setBooks(response.data);
    } catch (error) {
      console.error('Error fetching books:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/students/`, formData);
      setFormData({ name: '', email: '', grade: '' });
      setShowForm(false);
      fetchStudents();
    } catch (error) {
      console.error('Error creating student:', error);
      if (error.response?.data?.detail) {
        alert(error.response.data.detail);
      }
    }
  };

  const handlePersonalityAnalysis = async (studentId) => {
    try {
      const response = await axios.get(`${API_BASE_URL}/api/students/${studentId}/personality-analysis`);
      const analyses = response.data;
      
      if (analyses && analyses.length > 0) {
        const latest = analyses[0];
        showInfo(`?�향 분석 결과:
MBTI: ${latest.mbti_type}
?�약: ${latest.analysis_summary}
캐릭?? ${latest.character_description}`, '?�향 분석 결과');
      } else {
        showWarning('?�직 ?�향 분석 결과가 ?�습?�다. 게임??먼�? ?�?�보?�요!');
      }
    } catch (error) {
      console.error('?�향 분석 ?�류:', error);
      if (error.response?.data?.detail) {
        showError(error.response.data.detail);
      } else {
        showError('?�향 분석 ?�보�?가?�오??�??�류가 발생?�습?�다.');
      }
    }
  };

  const handleDeleteUser = async (studentId) => {
    if (window.confirm('?�말�????�용?��? ??��?�시겠습?�까?')) {
      try {
        await axios.delete(`${API_BASE_URL}/api/students/${studentId}`);
        showSuccess('?�용?��? ?�공?�으�???��?�었?�니??');
        fetchStudents(); // 목록 ?�로고침
      } catch (error) {
        console.error('??�� ?�류:', error);
        showError('?�용????�� �??�류가 발생?�습?�다.');
      }
    }
  };

  const toggleQuizSelector = (studentId) => {
    setShowQuizSelector(prev => ({
      ...prev,
      [studentId]: !prev[studentId]
    }));
  };

  const startQuiz = (studentId, bookId, difficulty) => {
    window.location.href = `/quiz/${bookId}/${difficulty}?student=${studentId}`;
  };

  return (
    <div className="container">
      <div className="page-header">
        <button 
          className="btn btn-primary"
          onClick={() => setShowForm(!showForm)}
        >
          {showForm ? '취소' : '+ ???�용???�록'}
        </button>
      </div>

      {showForm && (
        <div className="card">
          <h3>???�용???�록</h3>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label className="form-label">?�용???�름</label>
              <input
                type="text"
                className="form-input"
                value={formData.name}
                onChange={(e) => setFormData({...formData, name: e.target.value})}
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">이메일</label>
              <input
                type="email"
                className="form-input"
                value={formData.email}
                onChange={(e) => setFormData({...formData, email: e.target.value})}
                required
              />
            </div>
            
            <div className="form-group">
              <label className="form-label">?�년</label>
              <select
                className="form-input"
                value={formData.grade}
                onChange={(e) => setFormData({...formData, grade: e.target.value})}
              >
                <option value="">?�택</option>
                <option value="초등">초등</option>
                <option value="중등">중등</option>
                <option value="고등">고등</option>
              </select>
            </div>
            
            <div className="form-group">
              <button type="submit" className="btn btn-primary">?�록?�기</button>
            </div>
          </form>
        </div>
      )}

      <div className="students-grid">
        {students.map((student) => (
          <div key={student.id} className="card">
            <div className="student-info">
              <h3>?�� {student.name}</h3>
              <p><strong>?�록??</strong> {new Date(student.created_at).toLocaleDateString()}</p>
              <p><strong>?�메??</strong> {student.email}</p>
              {student.grade && <p><strong>?�년:</strong> {student.grade}</p>}
            </div>
            
            <div style={{marginBottom: '15px'}}>
              <button 
                className="btn btn-primary"
                onClick={() => toggleQuizSelector(student.id)}
                style={{width: '100%'}}
              >
                게임 ?�택?�기
              </button>
            </div>
            
            <div className="student-actions">
              <button 
                className="btn btn-secondary"
                onClick={() => handlePersonalityAnalysis(student.id)}
              >
                ?�향 분석
              </button>
              <button 
                className="btn-delete-small"
                onClick={() => handleDeleteUser(student.id)}
              >
                ??��
              </button>
            </div>
            
            {showQuizSelector[student.id] && (
              <div className="quiz-selector">
                <h4>게임 ?�택</h4>
                {books.length === 0 ? (
                  <p className="no-books">?�록??책이 ?�습?�다. 먼�? 책을 ?�록?�주?�요.</p>
                ) : (
                  books.map((book) => (
                    <div key={book.id} className="book-quiz-options">
                      <h5>{book.title}</h5>
                      <div className="difficulty-options">
                        <button 
                          className="btn btn-secondary quiz-difficulty"
                          onClick={() => startQuiz(student.id, book.id, 'very_easy')}
                        >
                          ??1?�계
                        </button>
                        <button 
                          className="btn btn-secondary quiz-difficulty"
                          onClick={() => startQuiz(student.id, book.id, 'easy')}
                        >
                          ?�� 2?�계
                        </button>
                        <button 
                          className="btn btn-secondary quiz-difficulty"
                          onClick={() => startQuiz(student.id, book.id, 'normal')}
                        >
                          ?�� 3?�계
                        </button>
                        <button 
                          className="btn btn-secondary quiz-difficulty"
                          onClick={() => startQuiz(student.id, book.id, 'hard')}
                        >
                          ?�� 4?�계
                        </button>
                        <button 
                          className="btn btn-secondary quiz-difficulty"
                          onClick={() => startQuiz(student.id, book.id, 'very_hard')}
                        >
                          ??5?�계
                        </button>
                      </div>
                    </div>
                  ))
                )}
                <button 
                  className="btn btn-secondary"
                  onClick={() => toggleQuizSelector(student.id)}
                >
                  취소
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {students.length === 0 && (
        <div className="empty-state">
          <div className="empty-icon">?��</div>
          <h3>?�록???�용?��? ?�습?�다</h3>
          <p>???�용?��? ?�록?�여 ?�작?�보?�요!</p>
        </div>
      )}
    </div>
  );
};

export default StudentsPage; 
